import React from 'react';

export const About = () => {
  return (
    <div>
      This is the about page.
    </div>
  )
}